export default "__VITE_PUBLIC_ASSET__c0deb757__"